<template>
  <div id="home-container">
    <div :class="[currentHeight > currentWidth ? 'centerbg-vertical' : 'centerbg-horizontal']">
      <div class="home-title mb-3">
        <h2 style="font-size:35px">
          <span >T</span>he
          <span style="color: #41ab5d;">T2T </span>
          <span>Genome </span>
          <span style="color: #41ab5d;">Web Server</span>
        </h2>
        <p style="font-size:20px">Online T2T genome annotation and functional analysis for plants and animals</p>
      </div>
    <div>
      <div id="home-search">
        <transition name="fade">
          <div id="button-container" v-if="showButtons">
            <button class="btn-hover color-3" @click="goToUpload">Analysis</button>
            <button class="btn-hover color-1" @click="showSearchContainer">Search</button>
          </div>
        </transition>
        <transition name="fade">
          <div id="search-container" v-if="showSearch">
            <el-button type="success" plain circle style="width: 20px; height: 20px; 
              margin:15px 10px 10px 10px; 
              display: flex; justify-content: center; align-items: center;" 
              @click="showUploadContainer">
              <i class="el-icon-arrow-left"></i>
            </el-button>

            <el-input class="el-input__inner1" placeholder="e.g. AT1G01010; Ath_Col-CEN_01G000010 " v-model="input" clearable @keyup.enter.native="search">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
              <el-select
                class="el-input__inner1"
                v-model="value"
                filterable
                clearable
                placeholder="Choose a species"
                style="margin-left: 10px; width: 50%;"
              >
                <!-- 渲染 options 数组中的每个物种 -->
                <el-option
                  v-for="item in options"
                  :key="item"
                  :label="item.replace(/_/g, ' ')"
                  :value="item"
                  @click.native="labelClick(item)"
                />
              </el-select>
            <el-button type="success" @click="search" style="margin-left: 10px; font-size: large; font-weight: 600;" :loading="isLoading">Search</el-button>
            <el-button type="primary" @click="example" style="margin-left: 10px; font-size: large; font-weight: 600;">Example</el-button>
          </div>
        </transition>
      </div>
    </div>
    </div>
    <div id="home-intro">
      <div id="home-intro-transition">
        <i class="el-icon-bottom" @click="goIntro"></i>
      </div>
      <home-box></home-box>
    </div>
    <!-- <home-intro></home-intro>
    <hr class="my-3"/>
    <home-box></home-box>
    <home-extra></home-extra> -->
  </div>
</template>

<script>
import HomeBox from './HomeBox.vue'
import { gethomesearch } from '@/api/api'
import { getNavList } from '@/api/api'
export default {
  components: { HomeBox },
  data() {
    return {
      value: '',
      species: '',
      options: [],  // 下拉菜单的选项列表
      currentWidth: window.innerWidth,
      currentHeight: window.innerHeight,
      input: '',
      isLoading: false,
      showButtons: true, // 控制按钮显示
      showSearch: false  // 控制搜索框显示
    }
  },
  mounted() {
    this.fetchNavList();  // 组件挂载后，立即请求数据

    window.addEventListener('resize', () => {
      this.currentWidth = window.innerWidth
      this.currentHeight = window.innerHeight
    })
    // console.log(this.options)
  },
  methods: {
    // 请求 navlist 数据
    async fetchNavList() {
      // 发起请求获取数据
      const response = await getNavList();

      // 更新 options 为返回的数据中的 genome 列表
      this.options = response.data.genome;
    },
    goToUpload() {
      const currentRoute = this.$route.fullPath; // 获取当前路由路径
      const targetRoute = '/upload'; // 目标路由

      if (currentRoute !== targetRoute) {
        this.$router.push({ path: targetRoute }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        }); // 忽略 NavigationDuplicated 错误
      }
    },
    showSearchContainer() {
      this.showButtons = false; // 突然隐藏按钮
      setTimeout(() => {
        this.showSearch = true;  // 1秒后渐变显示搜索框
      }, 300);
    },
    showUploadContainer() {
      this.showSearch = false; // 突然隐藏搜索框
      setTimeout(() => {
        this.showButtons = true;  // 1秒后渐变显示按钮
      }, 300);
    },
    example() {
      // 设置默认值给 input 和 species
      this.input = 'AT1G66340';  // 例如设置一些默认值到 input

      // 设置 value 为对应选项的 value
      const selectedSpecies = 'Arabidopsis_thaliana_Col-CEN'; // 默认选择的物种

      // 通过 options 查找对应的 value 设置给 value
      const selectedOption = this.options.find(option => option === selectedSpecies);
      if (selectedOption) {
        this.value = selectedOption; // 设置 v-model 的值
        this.species = selectedSpecies; // 设置 species 的值
      }
    },
    labelClick(label) {
      this.species = label
    },
    search() {
      if(this.value === ''){
        this.$message({
          message: 'Please select a species',
          type: 'warning'
        })
      } else {
      if (this.input === '') {
        this.$message({
          message: 'Please enter a gene ID',
          type: 'warning'
        })
      } else {
        this.isLoading = true;  // Set loading state to true
        gethomesearch(this.input,this.species).then(res => {
          this.isLoading = false;  // Set loading state to false after request completes
          if (res.data.gene === 404) {
              this.$message({
                message: 'No items found for ' + this.input + ' in ' + this.species.replace(/_/g, ' '),
                type: 'warning'
              })
            }
          else if(res.data.length > 1) {
            this.$router.push({ path: '/home/search/', query: { input:this.input, species:this.species } })
          }
          else{
            this.$router.push({ path: '/genome/' + this.species + '/details', query: { gene: res.data.gene[0]['gene_ID'], trans: res.data.gene[0]['transcript_ID'] } })
          }
          }).catch(() => {
            this.isLoading = false;  // Ensure loading state is reset on error
          })
          } 
        // this.$router.push({ path: '/genome/' + this.species + '/details', query: { gene: this.input.split('.').filter((item, index) => index != 1).join('.'),trans: this.input  } })
        // this.$router.push({ path: '/genome/' + this.species + '/details', query: { gene: this.input  } })
      }},
    goIntro() {
      document.getElementById('home-intro').scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.1s; /* 过渡时间，需要和上面的methods中的 showSearchContainer 中的时间协调一下 */
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.centerbg-horizontal {
  height: 102vh;
  position: relative;

  background: url(@/assets/img/home_bg7.png);
  // background-color: #CFE7D9;
  // background-color: #e4f5eb;
  background-repeat: no-repeat;
  // background-attachment: fixed;
  background-size: 100% 100vh;
  overflow: hidden !important;
}

.home-title {
  text-align: center;
  height: 88px;
  width: 100%;
  position: absolute;
  top: 25%;

  h2 {
    line-height: 60px;
    font-size: 5rem;
    font-weight: 600;
    font-family: 'Courier New', '', Courier, monospace;
  }

  p {
    font-size: 1.5rem;
    font-family: 'Courier New', Courier, monospace;
  }
}

.centerbg-vertical {
  width: 100%;
  height: 41.5rem;
  position: relative;

  background: url(@/assets/img/home_bg7.png);
  // background-color: #CFE7D9;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  overflow: hidden !important;

  .home-title {
    top: 25%;

    h2 {
      font-size: 3.5rem;
    }

    p {
      font-size: 1.07rem;
    }
  }
}

#home-search {
  width: 100%;
  position: absolute;
  top: 48%;
  display: flex;
  justify-content: center;
  align-items: center;

  #button-container {
    display: flex;
    justify-content: center; /* 按钮在容器内居中 */
    gap: 20px; /* 设置按钮之间的固定间距 */
    width: 50%; /* 与搜索框保持一致 */
    height: 3.6rem; /* 高度与搜索框保持一致 */
  }

  #search-container {

    width: 55%;
    // width: 1000px;
    display: flex;
    
    margin: 0 auto;

    

::v-deep(.el-input__inner) {
  border: 0.25rem solid #41AB5D;
  height: 3.6rem;
  font-size: 1.2rem;
}

::v-deep(.el-input__inner:focus) {
  box-shadow: rgba(253, 174, 107, 0.75) 0px 0px 22px 0px;
  border-color: rgb(253, 174, 107) !important;
}
    }

    .el-input__icon {
      line-height: 3.6rem;
      color: #333;
      font-size: 1.2rem;
      font-weight: 800;
    }
  }


#home-intro-transition {
  display: flex;
  position: relative;
  justify-content: center;

  img {
    position: absolute;
    top: -10vh;
    height: 10vh;
  }

  i {
    animation: scroll 1.5s cubic-bezier(.15, .41, .69, .94) infinite;
    position: absolute;
    cursor: pointer;
    top: -5rem;
    font-size: 2rem;
    font-weight: 700;
    color: #22B14C;
  }
}

.centerbg-vertical+#home-intro {
  #home-intro-transition {
    img {
      position: absolute;
      top: -4.5rem;
      height: 4.5rem;
    }

    i {
      visibility: hidden;
    }
  }
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(0.5rem);
  }

  100% {
    transform: translateY(0);
  }
}




.btn-hover {
    width: 200px;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    margin: 10px;
    width: 30%; /* 与搜索框保持一致 */
    height: 3.6rem; /* 高度与搜索框保持一致 */
    text-align: center;
    border: none;
    background-size: 300% 100%;

    border-radius: 50px;
    moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}

.btn-hover:hover {
    background-position: 100% 0;
    moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}

.btn-hover:focus {
    outline: none;
}

.btn-hover.color-1 {
    background-image: linear-gradient(to right, #25aae1, #40e495, #30dd8a, #2bb673);
    box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
}
.btn-hover.color-2 {
    background-image: linear-gradient(to right, #f5ce62, #e43603, #fa7199, #e85a19);
    box-shadow: 0 4px 15px 0 rgba(229, 66, 10, 0.75);
}

.btn-hover.color-3 {
    background-image: linear-gradient(to right, #667eea, #764ba2, #6B8DD6, #8E37D7);
    box-shadow: 0 4px 15px 0 rgba(116, 79, 168, 0.75);
}

.btn-hover.color-4 {
    background-image: linear-gradient(to right, #fc6076, #ff9a44, #ef9d43, #e75516);
    box-shadow: 0 4px 15px 0 rgba(252, 104, 110, 0.75);
}

.btn-hover.color-5 {
    background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
    box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
}

.btn-hover.color-6 {
    background-image: linear-gradient(to right, #009245, #FCEE21, #00A8C5, #D9E021);
    box-shadow: 0 4px 15px 0 rgba(83, 176, 57, 0.75);
}

.btn-hover.color-7 {
    background-image: linear-gradient(to right, #6253e1, #852D91, #A3A1FF, #F24645);
    box-shadow: 0 4px 15px 0 rgba(126, 52, 161, 0.75);
}

.btn-hover.color-8 {
    background-image: linear-gradient(to right, #29323c, #485563, #2b5876, #4e4376);
    box-shadow: 0 4px 15px 0 rgba(45, 54, 65, 0.75);
}

.btn-hover.color-9 {
    background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);
    box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);
}

.btn-hover.color-10 {
    background-image: linear-gradient(to right, #ed6ea0, #ec8c69, #f7186a, #FBB03B);
    box-shadow: 0 4px 15px 0 rgba(236, 116, 149, 0.75);
}

.btn-hover.color-11 {
    background-image: linear-gradient(to right, #eb3941, #f15e64, #e14e53, #e2373f);
    box-shadow: 0 5px 15px rgba(242, 97, 103, .4);
}

</style>